import { useTheme } from "@mui/material";
import { GRID_DETAIL_PANEL_TOGGLE_FIELD, GridColDef } from "@mui/x-data-grid-pro";
import { useFormat } from "@sinch/core/hooks/format";
import * as React from "react";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { CustomDetailPanelToggle } from "@sinch/components/application/RatesCompositionTable/EntityOverviewTable/CustomDetailPanelToggle";
import { useCommonRatesColumns } from "@sinch/components/application/RatesCompositionTable/hooks";
import { Row } from "@sinch/components/application/RatesCompositionTable/RatesCompositionTable";

export const useRatesColumns = (): GridColDef<Row>[] => {
  const { t } = useTranslation(["common", "draft"]);
  const { num } = useFormat();
  const { palette } = useTheme();
  const commonColumns = useCommonRatesColumns<Row>();

  return useMemo<GridColDef<Row>[]>(
    () => [
      ...commonColumns,
      {
        field: GRID_DETAIL_PANEL_TOGGLE_FIELD,
        renderCell: (params) => <CustomDetailPanelToggle {...params} />,
        resizable: false,
        display: "flex",
        width: 50,
        align: "center",
      },
    ],
    [t, num, palette.success.main]
  );
};
